import {
  useCorporateBondScreenerSidebarFilterContext,
} from '@/creditflowresearch/application/CorporateBondScreener/Sidebar/useCorporateBondScreenerSidebarFilterContext';
import useCheckboxFilter from '@/creditflowresearch/ui/components/corporate-bond-screener/Sidebar/Sections/hooks/useCheckboxFilter';
import useExcludeToggle from '@/creditflowresearch/ui/common/hooks/sidebar/useExcludeToggle';
import { ADDITIONAL_FILTER_OPTIONS } from './constants';

const useAdditionalFiltersSection = () => {
  const { isExcluded, activeKey, onToggleExclude } = useExcludeToggle({
    includeKey: 'includedAdditionalFilters',
    excludeKey: 'excludedAdditionalFilters',
    stateKey: 'isAdditionalFiltersExcluded',
    useFilterContext: useCorporateBondScreenerSidebarFilterContext,
  });

  const checkboxFilter = useCheckboxFilter({ filterKey: activeKey, items: ADDITIONAL_FILTER_OPTIONS });

  return {
    ...checkboxFilter,
    isExcludedEnabled: isExcluded,
    onChangeExclude: onToggleExclude,
  };
};

export default useAdditionalFiltersSection;
